import React from 'react';
import { getIconDef } from './AnnotationIcons';

const legendWrap = {
  background: 'white',
  borderRadius: 8,
  boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
  padding: '10px 14px',
  maxWidth: 220,
  maxHeight: 300,
  overflowY: 'auto',
  fontSize: 12,
};

const MapLegend = ({ annotations, routes, visible }) => {
  if (!visible) return null;

  const counts = {};
  annotations.forEach(a => {
    counts[a.annotation_type] = (counts[a.annotation_type] || 0) + 1;
  });

  const hasContent = Object.keys(counts).length > 0 || routes.length > 0;
  if (!hasContent) return null;

  return (
    <div style={legendWrap}>
      <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 13, color: '#111' }}>Map Legend</div>
      {Object.entries(counts).map(([type, count]) => {
        const def = getIconDef(type);
        return (
          <div key={type} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
            <div style={{ width: 24, height: 24, flexShrink: 0, overflow: 'hidden', position: 'relative' }}>
              <div
                dangerouslySetInnerHTML={{ __html: def?.svg || '' }}
                style={{ transform: 'scale(0.545)', transformOrigin: 'top left', position: 'absolute', top: 0, left: 0 }}
              />
            </div>
            <span style={{ flex: 1, color: '#374151' }}>{def?.label || type}</span>
            <span style={{ color: '#9ca3af', fontWeight: 600 }}>{count}</span>
          </div>
        );
      })}
      {routes.filter(r => !r.type || r.type === 'route').length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <line x1="2" y1="12" x2="22" y2="12" stroke="#3B82F6" strokeWidth="2" strokeDasharray="4 2"/>
            <polygon points="22,12 18,9 18,15" fill="#3B82F6"/>
          </svg>
          <span style={{ flex: 1, color: '#374151' }}>Route</span>
          <span style={{ color: '#9ca3af', fontWeight: 600 }}>{routes.filter(r => !r.type || r.type === 'route').length}</span>
        </div>
      )}
      {routes.filter(r => r.type === 'zone').length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <polygon points="4,20 12,4 20,20" fill="none" stroke="#16A34A" strokeWidth="2" strokeDasharray="4 2"/>
          </svg>
          <span style={{ flex: 1, color: '#374151' }}>Zone</span>
          <span style={{ color: '#9ca3af', fontWeight: 600 }}>{routes.filter(r => r.type === 'zone').length}</span>
        </div>
      )}
    </div>
  );
};

export default MapLegend;
